module.exports = __webpack_public_path__ + "img/HongKongTrust11.c194df11.png";